module.exports = __webpack_public_path__ + "img/9.dc9db1ba.jpg";